import { Button, styled } from '@mui/material';

export const CustomButton = styled(Button)(({ variant, size, disabled }) => ({
  borderRadius: '8px',
  padding: size === 'large' ? '12px 24px' : size === 'small' ? '6px 12px' : size === 'icon' ? '0px' : '8px 16px',
  fontWeight: 'bold',
  transition: 'background-color 0.3s, color 0.3s',
  textTransform: 'none',
  fontFamily: "'Poppins', sans-serif",

  ...(variant === 'primary' && {
    backgroundColor: 'var(--primary)',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'var(--sub-primary)',
    },
  }),

  ...(variant === 'secondary' && {
    backgroundColor: 'var(--sub-primary)',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'var(--primary)',
    },
  }),

  ...(variant === 'outlined' && {
    border: `2px solid var(--primary)`,
    color: 'var(--primary)',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(25, 0, 65, 0.1)',
    },
  }),

  ...(variant === 'outline-danger' && {
    border: '2px solid var(--text-error)',
    color: 'var(--text-error)',
    backgroundColor: '#fff',
    padding: size === 'large' ? '10px 22px' : size === 'small' ? '4px 10px' : '6px 14px',
    '&:hover': {
      backgroundColor: 'rgba(244, 67, 54, 0.1)',
    },
  }),

  ...(variant === 'icon' && {
    border: 'none',
    color: 'var(--primary)',
    minWidth: '32px',
    minHeight: '32px',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  }),

  ...(disabled && {
    backgroundColor: '#e0e0e0',
    color: '#b0b0b0',
    cursor: 'not-allowed',
    opacity: 0.5,
  }),
}));
